import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import InteractiveParticles from './InteractiveParticles'; // Importamos el componente único

const SeasonalEffects = () => {
  const [activeConfig, setActiveConfig] = useState(null);

  useEffect(() => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    
    let config = null;

    // --- CONFIGURACIONES POR TEMPORADA ---
    
    // 1. Acción de Gracias (Hojas flotantes - Estilo Deel clásico)
    if (month === 11 && day >= 1) { 
       config = {
         emojis: ['🍂', '🍁'],
         movement: 'float', // Se mueven para todos lados
         count: 15,
         minSize: 30,
         maxSize: 55
       };
    } 
    // 2. San Valentín (Corazones flotantes)
    else if (month === 2 && day >= 1 && day <= 15) {
       config = {
         emojis: ['❤️', '💖', '💌', '💕', '🌹'],
         movement: 'float',
         count: 30,
         minSize: 15,
         maxSize: 30
       };
    } 
    // 3. Pascua (Huevos y conejos)
    else if (month === 4 && day <= 15) { 
       config = {
         emojis: ['🥚', '🐣', '🐰'],
         movement: 'float',
         count: 30,
         minSize: 20,
         maxSize: 35
       };
    } 
    // 4. Halloween (Murciélagos y calabazas)
    else if (month === 10 && day >= 15) { 
       config = {
         emojis: ['🦇', '🎃', '🕸️', '👻'],
         movement: 'float',
         count: 35,
         minSize: 20,
         maxSize: 40
       };
    } 
    // 5. Navidad (Nieve - Cae hacia abajo)
    else if (month === 12) { 
       config = {
         emojis: ['❄️', '☃️', '🎄'], // Puedes usar un punto blanco '•' si prefieres nieve minimalista
         movement: 'fall', // Caída vertical
         count: 60,        // Más partículas para la nieve
         minSize: 10,      // Copos más pequeños
         maxSize: 25
       };
    }

    setActiveConfig(config);
  }, []);

  if (!activeConfig) return null;

  return ReactDOM.createPortal(
    <InteractiveParticles config={activeConfig} />, 
    document.body
  );
};

export default SeasonalEffects;